import { queryOptions } from "@tanstack/react-query";
import { getBlogPost, listBlogPosts } from "@/lib/opinly.functions";

export const blogPostsQuery = (cursor?: string) =>
  queryOptions({
    queryKey: ["opinly", "posts", cursor ?? ""],
    queryFn: () => listBlogPosts({ data: { limit: 12, cursor } }),
    staleTime: 5 * 60_000,
  });

export const blogPostQuery = (slug: string) =>
  queryOptions({
    queryKey: ["opinly", "post", slug],
    queryFn: () => getBlogPost({ data: { slug } }),
    staleTime: 5 * 60_000,
  });
